import { useMemo } from "react";
import { hasRoles } from "../../../core/Global";
import SideMenu, { ISideMenuItem } from "../../../components/layouts/aside/SideMenu";
import { FontAwesomeIcons } from "../../../core/Types";


interface ISideMenuGroup {
    name: string
    items: Array<{
        id: string
        name: string
        icon: FontAwesomeIcons
        link: string
        roles: string[]
    }>
}

export function useReportsSideMenuItems(): ISideMenuItem[] {
    return useMemo<ISideMenuItem[]>(() => {

        const reportRoles = ["JobsReport", "IsCustomer"]
        const balanceRoles = ["ManageBalanceSheet"]

        const groups: ISideMenuGroup[] = [
            {
                name: "Jobs Report",
                items: [
                    { id: "seg-dispatcher", name: "Dispatcher", icon: "user-headset", link: "/reports/jobs/dispatcher", roles: reportRoles },
                    { id: "seg-technician", name: "Technician", icon: "user-helmet-safety", link: "/reports/jobs/technician", roles: reportRoles },
                    { id: "seg-source", name: "Job Source", icon: "bullhorn", link: "/reports/jobs/source", roles: reportRoles },
                    { id: "seg-type", name: "Job Type", icon: "wrench", link: "/reports/jobs/type", roles: reportRoles },
                    { id: "seg-metro", name: "Metro", icon: "map", link: "/reports/jobs/metro", roles: reportRoles },
                    { id: "seg-payments", name: "Payments", icon: "credit-card", link: "/reports/jobs/payments", roles: reportRoles },
                    { id: "seg-closed", name: "Closed Jobs", icon: "circle", link: "/reports/jobs/closed", roles: reportRoles },
                    { id: "seg-canceled", name: "Canceled Jobs", icon: "circle", link: "/reports/jobs/canceled", roles: reportRoles },
                ]
            },
            {
                name: "Calls Report",
                items: [
                    { id: "calls-analytics", name: "Call Analytics", icon: "chart-simple", link: "/reports/calls", roles: reportRoles },
                ]
            },
            {
                name: "Payments",
                items: [
                    { id: "card-transactions", name: "Card Transactions", icon: "credit-card", link: "/reports/transactions", roles: balanceRoles },
                ]
            },
            {
                name: "Balance",
                items: [
                    { id: "balance-sheet", name: "Balance Sheet", icon: "chart-line", link: "/reports/balancesheet", roles: balanceRoles },
                    { id: "balance-transactions", name: "Transactions", icon: "arrow-right-arrow-left", link: "/reports/balancetransactions", roles: balanceRoles },
                ]
            },
        ]

        const result: ISideMenuItem[] = []
        for (const g of groups) {
            const visible = g.items.filter(it => hasRoles(it.roles))
            if (visible.length === 0) continue
            result.push({ seperator: true, name: g.name })
            for (const it of visible) {
                result.push({ id: it.id, name: it.name, icon: it.icon, link: it.link })
            }
        }
        return result

    }, [])
}


export default function ReportsSideMenu() {
    const items = useReportsSideMenuItems()
    return <SideMenu items={items} />
}
